import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import { Link, Switch, Route } from 'react-router-dom';
import List from '@material-ui/core/List';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import MenuIcon from '@material-ui/icons/Menu';
import ListItem from '@material-ui/core/List';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';


import { mailFolderListItems, otherMailFolderListItems } from './tileData';
//import HomeTabs from './HomeTabs';
import FilteredDeals from './FilteredDeals';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import ZipModal from './ZipModal';
import {API} from 'aws-amplify';
import {Auth} from 'aws-amplify';
import DealDetail from '../DealDetail';
import CarMakes from '../CarMakes';
import CompareDeals from '../CompareDeals';
import DealsByMake from '../DealsByMake';
import FavoriteDeals from '../FavoriteDeals';
import Settings from '../Settings';
import Contact from '../Contact';

import FavoriteIcon from '@material-ui/icons/Favorite';
import SettingsIcon from '@material-ui/icons/Settings';
import EmailIcon from '@material-ui/icons/Email';
import CarIcon from '@material-ui/icons/DirectionsCar';
import ReportIcon from '@material-ui/icons/Report';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import VanIcon from '@material-ui/icons/AirportShuttle';
import ThumbsUpIcon from '@material-ui/icons/ThumbUp';
import AccountMenu from './AccountMenu';
import Paper from '@material-ui/core/Paper';

import Grid from '@material-ui/core/Grid';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';

import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Divider from '@material-ui/core/Divider';

import FormLabel from '@material-ui/core/FormLabel';
import ReactPixel from 'react-facebook-pixel';
import Footer from '../Footer';

const logo = require('../images/hipkar-logo-text.png');



const marks = [
  {
    value: 0,
    label: '0°C',
  },
  {
    value: 20,
    label: '20°C',
  },
  {
    value: 37,
    label: '37°C',
  },
  {
    value: 100,
    label: '100°C',
  },
];

const styles = theme => ({
  menuItem: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& $primary, & $icon': {
        color: theme.palette.common.white,
      },
    },
  },
  primary: {},
  toolbarButtons: {
    display: 'flex',
    marginLeft: 'auto',
    flexDirection: 'row',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  hipkarLogo: {
    // height: '1.28cm',
    // width: '4.56cm',
    marginTop: 12,
    maxWidth: '60%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '18%',
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: '18%',
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '18%',
    },
  },
  root: {
    width: '100%',
    height: '100%',
    marginTop: theme.spacing.unit * 3,
    zIndex: 1,
    //overflow: 'hidden',
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  flex: {
    flex: 1,
  },
  appFrame: {
    marginLeft: -8,
    position: 'absolute',
    display: 'flex',
    width: '100%',
    height: 'calc(100% - 42px)',
    zIndex: 1,
  },
  appBar: {
    backgroundColor: theme.palette.primary.dark,
    position: 'fixed',
    top: 0,
    //marginLeft: drawerWidth,
    width: '100%',
    zIndex: 2,
  },
  toolBar: {
    marginTop: 0,
  },
  navIconHide: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },

  button: {
    margin: theme.spacing.unit,
  },
  loginButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
});

class ResponsiveDrawer extends React.Component {

  constructor(props) {
    super(props);
    this.handleLogout = this.handleLogout.bind(this);
    this.handleLeasyZipChange = this.handleLeasyZipChange.bind(this);
    this.handleWindowClose = this.handleWindowClose.bind(this);
    //console.log('RD this.props.authStatus: ' + this.props.authStatus);
    this.state = {
      authStatus: this.props.authStatus || false,
      username: null,
      mobileOpen: false,
      leasyZip: '',
      topLocalDeals: [],

    };
    //console.log('in cons for ResponsiveDrawer. value of authStatus: ' + this.props.authStatus);
    //console.log('in cons for ResponsiveDrawer. value of leasyZip: ' + this.state.leasyZip);

    //facebook pixel
    //const advancedMatching = { em: 'some@email.com' }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/pixel-with-ads/conversion-tracking#advanced_match
    const options = {
        autoConfig: true, 	// set pixel's autoConfig
        debug: false, 		// enable logs
    };
    ReactPixel.init('512966586135557', {}, options);
    ReactPixel.pageView();
  }

  handleWindowClose = async (e) => {
      e.preventDefault();
      Auth.signOut()
          .then(
              localStorage.setItem('isLoggedIn', false),
              this.setState(() => {
                  return {
                      authStatus: false
                  }
              })
          )
          .catch(err => console.log(err))
  }

  componentWillMount() {
      //this.validateUserSession();
      //window.addEventListener('beforeunload', this.handleWindowClose);
      //console.log('componentWillMount()...');
  }

  componentWillUnMount() {
      //window.removeEventListener('beforeunload', this.handleWindowClose);
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.userID !== prevProps.userID) {
      this.fetchData(this.props.userID);
    }
  }

  valuetext(value) {
    return `${value}°C`;
  }

  validateUserSession() {
      let checkIfLoggedIn = localStorage.getItem('isLoggedIn');
      //console.log('in ResponsiveDrawer validateUserSession - checkIfLoggedIn: ' + checkIfLoggedIn);
      let username = localStorage.getItem('username');
      //console.log('username: ' + username);
      if(checkIfLoggedIn === 'true'){
          //console.log('resp draw: logged in');
          this.setState(() => {
              return {
                  authStatus: true,
                  username: username
              }
          })
      } else {
        console.log('resp draw: NOT logged in');
          this.setState(() => {
              return {
                  authStatus: false
              }
          })
      }
  }


  handleLeasyZipChange(newLeasyZip) {
    //console.log('now setting leasyZip to: ' + newLeasyZip);
    //this.fetchTopDeals(newLeasyZip);
    this.fetchAllLocalDeals(newLeasyZip);
    this.setState({ leasyZip: newLeasyZip });
  }

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  fetchTopDeals = async (zip) => {
    //console.log('now in fetchTopDeals');
    let requestParams = {
        headers: {'content-type': 'application/json'},
        body : {
            'zip': zip
        }
    }

    API.post('leasy','/get-top-deals', requestParams)
        .then(data => {

          this.setState({
              topLocalDeals: data,
              resultingDeals: data,
          });
          return data;
        })
        .catch (err => console.log(err))

  }

  fetchAllLocalDeals = async (zip) => {
    //console.log('now in fetchAllLocalDeals');
    let requestParams = {
        headers: {'content-type': 'application/json'},
        body : {
            'zip': zip
        }
    }

    API.post('leasy','/get-all-local-deals', requestParams)
        .then(data => {
          //console.log(data);
          //data.sort(this.compareDeals);
          this.setState({
              allLocalDeals: data
          });
          return data;
        })
        .catch (err => console.log(err))
  }

  handleLogout = (e) => {
    this.signOut(e);
  }

  signOut = async(e) => {
      //console.log('in ResponsiveDrawer signOut');
      e.preventDefault();
      Auth.signOut()
          .then(
              localStorage.setItem('isLoggedIn', false),
              this.props.onAuthComplete(),
              this.setState(() => {
                  return {
                      authStatus: false
                  }
              })

          )
          .catch(err => console.log(err));
  }



// 2 | 2 | 6 | 2
  render() {
    const { classes, theme, location, authStatus, username, fS } = this.props;
    const { topLocalDeals, leasyZip, allLocalDeals, resultingDeals, carMakes } = this.state;

    let fontSize = fS;
    (fontSize === '') ? fontSize = "inherit" : fontSize = "small";


    //console.log('location: ' + location.pathname);
    var topLocalOfferSelected = (location.pathname == '/');
    var carMakesSelected = (/^\/makes/.test(location.pathname));
    var carTypesSelected = (/^\/type/.test(location.pathname));
    var discussionSelected = (/^\/discuss/.test(location.pathname));


    const drawer = (
      <div>
        <Divider />
        <MenuList onClick={this.handleDrawerToggle}>
            <MenuItem className={classes.menuItem} component={Link} to={'/'} button selected={topLocalOfferSelected}>
              <ListItemIcon className={classes.icon}>
                <LocalOfferIcon />
              </ListItemIcon>
              <ListItemText classes={{ primary: classes.primary }} primary="Top Local Offers" />
            </MenuItem>
            <MenuItem className={classes.menuItem} component={Link} to={'/makes'} button selected={carMakesSelected}>
              <ListItemIcon className={classes.icon}>
                <CarIcon />
              </ListItemIcon>
              <ListItemText classes={{ primary: classes.primary }} primary="Browse Car Makes" />
            </MenuItem>
            <MenuItem className={classes.menuItem} component={Link} to={'/compare'} button>
              <ListItemIcon className={classes.icon}>
                <VanIcon />
              </ListItemIcon>
              <ListItemText classes={{ primary: classes.primary }} primary="Compare Offers" />
            </MenuItem>
            <MenuItem className={classes.menuItem} component={Link} to={'/deals/detail/e0de94f2-388a-415e-a39f-63110640861f'} button>
              <ListItemIcon className={classes.icon}>
                <ThumbsUpIcon />
              </ListItemIcon>
              <ListItemText classes={{ primary: classes.primary }} primary="Featured Offer" />
            </MenuItem>
        </MenuList>
        <Divider />
        <List onClick={this.handleDrawerToggle}>
          <MenuItem className={classes.menuItem} component={Link} to={'/favorites'}  button>
            <ListItemIcon className={classes.icon}>
              <FavoriteIcon />
            </ListItemIcon>
            <ListItemText classes={{ primary: classes.primary }} primary="Favorites" />
          </MenuItem>
          <MenuItem className={classes.menuItem} component={Link} to={'/settings'}  button>
            <ListItemIcon className={classes.icon}>
              <SettingsIcon />
            </ListItemIcon>
            <ListItemText classes={{ primary: classes.primary }} primary="Settings" />
          </MenuItem>
        </List>
      </div>
    );


    return (
      <div className={classes.root}>
        
            <AppBar className={classes.appBar} elevation={0}>
            <Grid container alignItems="stretch" justify="center" spacing={0}>
            <Grid item xs={0} sm={0} md={0} lg={2}>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={8}>
              <Toolbar className={classes.toolBar} >
                <a href="https://hipkar.com">
                  <img src={logo} className={classes.hipkarLogo}  alt="HipKar - get the best deal on a car lease" />
                </a>
                <div className={classes.toolbarButtons}>
                  <ZipModal onLeasyZipChange={this.handleLeasyZipChange} />
                  {
                    authStatus ?
                      <AccountMenu onLogout={this.handleLogout} username={username}/>
                      : <Button component={Link} to="/login">Login</Button>
                  }
                </div>
              </Toolbar>
           
            </Grid>
            <Grid item xs={0} sm={0} md={0} lg={2}>
            </Grid>

            </Grid>
          </AppBar>
       
        

        <div className={classes.appFrame}>
          <Switch>
            <Route path='/deals/detail/:id' render={(props) => <DealDetail {...props} authStatus={authStatus} allLocalDeals={allLocalDeals} leasyZip={leasyZip} />}
            />
            <Route path='/' exact
              render={(props) => <FilteredDeals {...props} authStatus={authStatus} allLocalDeals={allLocalDeals} leasyZip={leasyZip} />}
            />
          </Switch> 
          
        </div>
        
        {/* <Footer/>  */}


      </div>
    );
  }
}

ResponsiveDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(ResponsiveDrawer);



// WEBPACK FOOTER //
// ./src/components/dashboard/ResponsiveDrawerNew.jsx